import { render, staticRenderFns } from "./Ganadores.vue?vue&type=template&id=791247a0&"
import script from "./Ganadores.vue?vue&type=script&lang=js&"
export * from "./Ganadores.vue?vue&type=script&lang=js&"
import style0 from "./Ganadores.vue?vue&type=style&index=0&id=791247a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports